export function initializeTemplateWithMetadata(
    templateData: any,
    metadata: { pnoLogo: string; companyName: string; companyAddress: string; currentDate: string },
) {
    const { pnoLogo, companyName, companyAddress, currentDate } = metadata;

    // Recursively replace "text" key values in the templateData object
    const replaceTextInTemplateData = (data: any) => {
        if (Array.isArray(data)) {
            return data.map((item) => replaceTextInTemplateData(item));
        } else if (typeof data === 'object' && data !== null) {
            return Object.fromEntries(
                Object.entries(data).map(([key, value]) => {
                    if (['text', 'url'].includes(key) && typeof value === 'string') {
                        return [
                            key,
                            value
                                .replace(/{{pnoLogo}}/g, pnoLogo)
                                .replace(/{{companyName}}/g, companyName)
                                .replace(/{{companyAddress}}/g, companyAddress)
                                .replace(/{{date}}/g, currentDate),
                        ];
                    }
                    return [key, replaceTextInTemplateData(value)];
                }),
            );
        }
        return data;
    };

    // Create a deep copy of the templateData to avoid mutating the original object
    const templateDataCopy = JSON.parse(JSON.stringify(templateData));

    // Replace text in the copied templateData
    const updatedTemplateData = replaceTextInTemplateData(templateDataCopy);

    // Return the updated templateData
    return updatedTemplateData;
}
